import { Input, Label, Slider } from '@iwoca/orion';

import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useLocale } from 'hooks/useLocale';
import { TCalculatorProducts } from 'types';
import {
  MAX_PUBLIC_WITHDRAWAL_FEE,
  MAX_WITHDRAWAL_FEE,
  MIN_WITHDRAWAL_FEE,
} from '../filterConfigs.helper';
import standAloneCalculatorStyles from '../StandAloneCalculator.module.css';

import styles from './WithdrawalFeeFilter.module.css';

type TProps = {
  product: TCalculatorProducts;
  value: string;
  onChange: (withdrawalFee: string) => void;
};

export const WithdrawalFeeFilter = ({ product, value, onChange }: TProps) => {
  const { isLoggedIn } = useIntroducerContext();
  const { isUK } = useLocale();
  const maxValue =
    !isLoggedIn && isUK ? MAX_PUBLIC_WITHDRAWAL_FEE : MAX_WITHDRAWAL_FEE;

  const handleBlur = (newValue: string) => {
    if (Number(newValue) > 9) {
      onChange('9');
    } else if (Number(newValue) < Number(MIN_WITHDRAWAL_FEE)) {
      onChange(MIN_WITHDRAWAL_FEE);
    }
  };

  const handleIntegerChange = (value: string) => {
    const valueAsInteger = value.replace(/[^0-9]+/g, '');
    onChange(valueAsInteger);
  };

  return (
    <div className={styles.container}>
      <div className={styles.inputContainer}>
        <Label htmlFor="withdrawal-fee" className={styles.label}>
          Withdrawal fee
        </Label>
        <Input
          id="withdrawal-fee"
          className={styles.input}
          disabled={product !== 'flexi24'}
          value={value}
          onChange={(e) => handleIntegerChange(e.target.value)}
          onBlur={(e) => handleBlur(e.target.value)}
        />
      </div>
      <Slider
        data-testid="withdrawal-fee-slider"
        labelClassName={standAloneCalculatorStyles['label']}
        min={Number(MIN_WITHDRAWAL_FEE)}
        max={Number(maxValue)}
        leftLabel="0%"
        rightLabel={`${maxValue}%`}
        disabled={product !== 'flexi24'}
        value={value}
        step={1}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
